import { useMemo } from 'react'
import zhCN from 'antd/lib/locale/zh_CN'
import { Table, ConfigProvider } from 'antd'

export default function TableHasPagenation({
  pageData,
  onPageSizeChange = () => {},
  onTableChange= () => {},
  rowSelection = null,
  rowKey = '',
  loading,
  columns = [],
  components = null,
  scroll = false
}) {
  const { list, pageIndex, total, pageSize } = useMemo(() => {
    return {
      list: pageData.result || [],
      pageIndex: pageData.pageIndex || 0,
      total: pageData.recordCount || 0,
      pageSize: pageData.pageSize || 10
    }
  }, [pageData])

  return (
    <div>
      <ConfigProvider locale={zhCN}>
        <Table
          dataSource={list}
          components={components}
          columns={columns}
          rowKey={rowKey}
          loading={loading}
          rowSelection={rowSelection}
          scroll={scroll}
          onChange={onTableChange}
          pagination={{
            showSizeChanger: true,
            position: ['bottomLeft'],
            current: pageIndex,
            pageSize: pageSize,
            onChange: (page, pageSize) =>
              onPageSizeChange({
                pageIndex: page,
                pageSize: pageSize
              }),
            total: total
          }}
        />
      </ConfigProvider>
    </div>
  )
}
